export default __webpack_public_path__ + "static/media/logo.5d217c0d.png";